<template>
    <div class="toast">
        <!-- 对话框 -->
        <el-dialog :visible.sync="isshow" @close='closeFn'>
            <div slot="title" class="jumFpeedback_head">
                <img src="../../assets/images/login/logo.png" alt="">
                <b></b>
                <span>{{title}}</span>
            </div>
            <div class="jumpFeedback_body" style="height: 500px;overflow-y:hidden;overflow-x: hidden; ">
                <div class="jumpFeedback_content" style="height: 450px;overflow: hidden;overflow-y: scroll;" v-html="content">

                </div>
            </div>
            <div class="dialog-footer">
                <el-button @click="closeFn" type="info">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'agreement',
  data() {
    return {
      content: '',
      title: '',
      isshow: false
    }
  },
  methods: {
    changeStatus() {
      this.isClose(false);
    },
    closeFn() {
      this.$emit("closeState")
      console.log('ddddd')
    },
    getcontent() {
      var timestamp  = Date.parse(new Date())
      var that = this
      let params = {
        name: (this.contentId === 1) ? '用户协议' : '隐私政策'
      }
      this.title = params.name
      axios({
        method: 'get',
        url: '/realNet/richText/selectRichText?_=' + timestamp,
        params: params
      })
        .then(function(res) {
          var resobj = res.data
          if (resobj.code === 200) {
            var content = resobj.result.content
            that.content = content[0].content
          } else {
            that.$message({
              showClose: true,
              message: resObj.message,
              type: 'warning',
              duration: 1000
            })
          }
        })
        .catch(function(e) {
          console.log(e)
        })
    }
  },
  props: {
    state: {
      type: Boolean,
      default: false
    },
    contentId: {
      type: Number,
      default: 1
    }
  },
  mounted() {
    this.getcontent()
  },
  watch : {
    contentId () {
      this.getcontent()
    },
    state () {
      this.isshow = this.state
    }
  }
}
</script>

<style lang='scss' scoped>
    .jumFpeedback_head {
        display: flex;
        align-items: center;

        b {
            width: 4px;
            height: 4px;
            margin: 0 10px;

            background-color: #3bc0d0;
            border-radius: 50%;
            display: inline-block;
        }
        span {
            font-size: 18px;
            color: #3bc0d0;
        }
    }
    .jumpFeedback_body {
        width: 100%;
        padding: 20px 30px 10px;
        box-sizing: border-box;
        display: block;
        word-break: break-all;
        word-wrap: break-word;
        .user {
            width: 100%;
            height: 55px;
            margin-bottom: 20px;
            border-bottom: 1px solid #e1e9eb;
            display: flex;
            align-items: center;
            input {
                width: 90%;
                height: 30px;
                border: none;

                outline: none;
                font-size: 16px;

                &::-webkit-input-placeholder {
                    color: #ccc;
                }
                &::-moz-placeholder {
                    color: #ccc;
                }
                &::-ms-input-placeholder {
                    color: #ccc;
                }
            }
        }

        .code {
            width: 100%;

            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .agreement {
            margin: 20px 0;
        }
        .inputSty {
            width: 100%;

            margin: 10px 0;
        }

        .loginBtn {
            width: 360px;
            height: 50px;
            margin-top: 20px;

            background-color: rgb(221,225,226);
            border-radius: 8px;
            cursor: pointer;

            display: flex;
            justify-content: center;
            align-items: center;

            span {
                font-size: 18px;
                color: #fff;
                letter-spacing: 1px;
            }
        }
        & > .active {
            background-color: #409EFF;
        }
    }
    .dialog-footer {
        width: 100%;
        height: 60px;
        padding: 0 10px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        box-sizing: border-box;
        background-color: rgb(243, 247, 248);
        border-radius: 0 0 8px 8px;
        span {
            font-size: 14px;
            color: #666;
        }
        .elseLogin {
            width: 45%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            cursor: pointer;
        }
    }
</style>